module.exports = __webpack_public_path__ + "img/section3-1-desktop.07bc0050.png";